import { app } from '../../../app';

app.component('googleMarketplaceConfigurationError', {
    bindings: {errorCode: '<'},
    templateUrl: require('./google-marketplace-configuration-error.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/google-marketplace-configuration-error/google-marketplace-configuration-error.component.js